import { camelToSnakeKeys } from '@convenia/helpers'
import { mapCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'
import { PERSONAL_AREA } from '@convenia/common-organisms/SystemFields/content/consts'

export const mapHandicap = (data = {}) => ({
  ...data,
  hasDeficiency: !!data?.id,
  disabilityId: data?.disability?.id,
})

export const mapHandicapInput = ({ schema, data } = {}) => ({
  ...camelToSnakeKeys({
    disabilityId: data?.hasDeficiency ? data?.disabilityId : null,
    observations: data?.hasDeficiency ? data?.observations : null,
  }),
  custom_fields: mapCustomFieldValues({
    data: data?.hasDeficiency ? data : {},
    schema,
    sectionId: PERSONAL_AREA.HANDICAP,
  })
})
